import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
  Typography,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import React from "react";
import Loader from "../../../../../components/Loader";
import { useGeologicalContacts } from "../hooks/useGeologicalContacts";
import DataAdminTable from "../../../../../components/DataAdminTable";
import { TableWrapper } from "../utils";

function GeologicalContacts({
  selectedWell,
  isEditMode = false,
  selectedWellLabel,
}) {
  const {
    isLoading,
    error,
    refetch,
    state,
    setter,
    GEOLOGICAL_CONTACTS_TABLE_COLUMNS,
  } = useGeologicalContacts(selectedWell);

  if (error) return "An error has occurred: " + error.message;
  return (
    <>
      {isLoading && (
        <Paper style={{ width: "100%", margin: "8px 0" }}>
          <Loader />
        </Paper>
      )}
      <Accordion defaultExpanded={isEditMode} disabled={!selectedWell}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Box style={{ width: "100%" }}>
            <Typography variant="h3">{`Geological Contacts ${
              selectedWellLabel ? `(${selectedWellLabel})` : ""
            }`}</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <TableWrapper>
            <DataAdminTable
              pageSize={10}
              isLoading={isLoading}
              label="TITLE"
              columns={GEOLOGICAL_CONTACTS_TABLE_COLUMNS}
              data={state}
              height="200px"
              updateHandler={setter}
              endpoint="list-wells-hydrogeology-formations"
              ndxField="ndx"
              selectedNdx={selectedWell}
              handleRefresh={refetch}
            />
          </TableWrapper>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default GeologicalContacts;
